import React from 'react'
import {
  areaList,
  AreaType,
  CURRENT_LOCATION,
  getPrefecture,
  Locale,
  StationType,
  WHOLE_LOCATION,
  UrlPrefix,
  PrefectureType,
  getArea,
  areaInPrefectureForCarList
} from '../../config/constants'
import { ListMode } from '../user/stations/MapListNavbar'
import styles from './TagButtons.scss'

export const TagButtons = ({
  mode,
  area,
  locale,
  prefecture,
  stationType,
  query
}:{
  area: string,
  locale: Locale,
  prefecture?: PrefectureType,
  mode: ListMode,
  stationType: StationType,
  query?: string,
}) => {
  return <ul className={['d-block list-unstyled align-items-center mb-md-1 mb-0 ml-md-3 ml-1 pt-1', styles.scroll].join(' ')}>
  {area === WHOLE_LOCATION
  ? areaList.map((area: AreaType) => <li className={['d-inline-block', styles.prefectureItem].join(' ')}>
      <div className={[styles.prefectureItemText].join(' ')}>
        <a
          className={['d-flex flex-column align-items-center justify-content-center  px-1 text-decoration-none', styles.btnText].join(' ')}
          href={`/${locale}/${UrlPrefix.user}${stationType === StationType.car ? 'car-list' : 'stations'}/${area}/${query || ''}`}
        >
          {getArea(locale, area)}
        </a>
      </div>
    </li>
    )
  : area !== CURRENT_LOCATION && areaInPrefectureForCarList[area].map(prefecture => <li className={['d-inline-block', styles.prefectureItem].join(' ')}>
      <div className={[styles.prefectureItemText].join(' ')}>
      {prefecture === PrefectureType.hokkaido
        ? <a
            className={['d-flex flex-column align-items-center justify-content-center px-1 text-decoration-none', styles.btnText].join(' ')}
            href={`/${locale}/${UrlPrefix.user}${stationType === StationType.car ? 'car-list' : 'stations'}/${PrefectureType.hokkaido}/${query}`}
          >
            {getPrefecture(locale, prefecture)}
          </a>
        : <a
            className={['d-flex flex-column align-items-center justify-content-center px-1 text-decoration-none', styles.btnText].join(' ')}
            href={`/${locale}/${UrlPrefix.user}${stationType === StationType.car ? 'car-list' : 'stations'}/${prefecture !== PrefectureType.hokkaido && area === AreaType.hokkaido ? AreaType.tohoku : area}/${prefecture}/${query}`}
          >
            {getPrefecture(locale, prefecture)}
          </a>
      }
      </div>
    </li>
    )
  }
</ul>
}

TagButtons.displayName = 'TagButtons'
export default TagButtons
